export type UserRegionType =
  | '충남'
  | '부산'
  | '울산'
  | '인천'
  | '대구'
  | '대전'
  | '서울'
  | '전북특별자치도'
  | '충북'
  | '제주특별자치도'
  | '경기'
  | '경남'
  | '경북'
  | '강원특별자치도'
  | '세종특별자치시'
  | '전남'
  | '광주'
  | '전라남도';

export const regionCustomCodeMap: Record<UserRegionType, string> = {
  경기: '41',
  강원특별자치도: '42',
  충북: '43',
  충남: '44',
  전북특별자치도: '45',
  전남: '46',
  전라남도: '46',
  경북: '47',
  경남: '48',
  서울: '11',
  부산: '26',
  대구: '27',
  인천: '28',
  광주: '29',
  대전: '30',
  울산: '31',
  세종특별자치시: '49',
  제주특별자치도: '50',
};

interface IMapRegionToCustomCodeParam {
  regionDepth1: UserRegionType;
}

const isUserRegionType = (region: string): region is UserRegionType => {
  return Object.keys(regionCustomCodeMap).includes(region);
};

export const mapRegionToCustomCode = ({ regionDepth1 }: IMapRegionToCustomCodeParam) => {
  if (isUserRegionType(regionDepth1)) {
    return regionCustomCodeMap[regionDepth1];
  }

  return 'wrong';
};
